import Constant from "./Constant";
import Util from "./common/Util";

const AppDelegate = {
  app: null,
  user: {

    username: null,
    status: null,

    jwt: null,
    permissionDict: null,
  },

  //-------------------------
  pageCache: {},  // should access directly; use get/set cache function
  getCache: (key, defaultVal) => {
    if (AppDelegate.pageCache[window.location.pathname+"/"+key]) {
      return AppDelegate.pageCache[window.location.pathname+"/"+key];
    } else {
      return defaultVal;
    }
  },
  setCache: (key, value) => {
    AppDelegate.pageCache[window.location.pathname+"/"+key] = value;
  },
  deleteCache: (key) => {
    delete AppDelegate.pageCache[window.location.pathname+"/"+key];
  },
  printCache: () => {
    console.log(JSON.stringify(AppDelegate.pageCache));
  }
  //-------------------------
};
// load from localstorage
if (localStorage.getItem("user")) {
  AppDelegate.user = JSON.parse(localStorage.getItem("user"));
}

// AppDelegate.cancelRequest = () => {
//   return AndersonConnector.cancelRequest();
// }

//----------------------------------------
// Permission related

//----------------------------------------
AppDelegate.clearSession = () => {
  localStorage.removeItem("user");
  AppDelegate.user = {
    username: null,
    status: null,
    jwt: null,
    permissionDict: null,
  };
  // AppDelegate.customerList = [];
  // AppDelegate.customerDict = {};
  // AppDelegate.staffList = [];
  // AppDelegate.pageCache = {};
}



AppDelegate.preprocessResponse = (response) => {
  if (response.status === 200) {
    if (response.data) {
      if (response.data.code === 403) {
        AppDelegate.clearSession();
        window.location.href = "/login";
      }
    }
  } else {
    console.error("Network error: " + response);
  }
}

//----------------------------------------------------------------------
// API functions
AppDelegate.reqLogin = async (request) => {
  AppDelegate.clearSession();
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/login";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
  })
  const response = await rawResp.json();

  if (response.code === 200) {
    // login successfully -> save the jwt
    const user = response.payload;
    // user.permissionDict = Util.deserializePermission(user.accessRight);
    AppDelegate.user = user;
    AppDelegate.user.jwt = user.jwt;
    localStorage.setItem("user", JSON.stringify(user));
  }
  return response;
}

AppDelegate.reqCase = async (request = {}) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/listCase";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${AppDelegate.user.jwt}`,
    }
  })
  const response = await rawResp.json();

  if (response.code === 403) {
    AppDelegate.clearSession();
    window.location.href = "/login";
  }

  return response;
}

AppDelegate.reqListUploadLink = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/listUploadLink";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${AppDelegate.user.jwt}`,
    }
  })
  const response = await rawResp.json();

  if (response.code === 403) {
    AppDelegate.clearSession();
    window.location.href = "/login";
  }

  return response;
}

AppDelegate.reqListDownloadLink = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/listDownloadLink";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${AppDelegate.user.jwt}`,
    }
  })
  const response = await rawResp.json();

  if (response.code === 403) {
    AppDelegate.clearSession();
    window.location.href = "/login";
  }

  return response;
}

AppDelegate.reqSubmitQuery = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/submitQuery";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
  })
  const response = await rawResp.json();
  return response;
}

AppDelegate.reqGenUploadURL = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/genUploadURL";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
  })
  const response = await rawResp.json();
  return response;
}

AppDelegate.reqValidateUploadLink = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/validateUploadLink";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
  })
  const response = await rawResp.json();
  return response;
}

AppDelegate.reqFinishUpload = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/finishUpload";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
  })
  const response = await rawResp.json();
  return response;
}

AppDelegate.reqRequestDownloadPin = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/requestDownloadPin";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
  })
  const response = await rawResp.json();
  return response;
}

AppDelegate.reqCheckDownloadLink = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/checkDownloadLink";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
  })
  const response = await rawResp.json();
  return response;
}

AppDelegate.reqGetDownloadLink = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/getDownloadLink";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    }
  })
  const response = await rawResp.json();
  return response;
}

AppDelegate.reqNewDownloadLink = async (request) => {
  const url = process.env.REACT_APP_API_BASE_URL + "/api/v1/newDownloadLink";
  const rawResp = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${AppDelegate.user.jwt}`,
    }
  })
  const response = await rawResp.json();

  if (response.code === 403) {
    AppDelegate.clearSession();
    window.location.href = "/login";
  }

  return response;
}



export default AppDelegate;
